import React, { useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import styles from './modal.module.scss';

const Modal = ({
  children,
  closeBackground = true,
  closeEsc = false,
  onClose,
  variant, // 'dialog' — компактный диалог по центру
}) => {
  const containerModal = useRef(null);
  const isDialog = variant === 'dialog';

  useEffect(() => {
    document.body.classList.add(styles.open);
    return () => {
      document.body.classList.remove(styles.open);
    };
  }, []);

  useEffect(() => {
    if (!closeEsc || typeof onClose !== 'function') {
      return undefined;
    }

    const onKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', onKeyDown);

    return () => {
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [closeEsc, onClose]);

  return ReactDOM.createPortal(
    <div
      ref={containerModal}
      className={styles.modal}
      onKeyDown={() => {}}
      onClick={({ target }) => {
        if (closeBackground && target === containerModal.current) {
          onClose();
        }
      }}
    >
      <div className={isDialog ? `${styles.body} ${styles.bodyDialog}` : styles.body}>
        {children}
      </div>
    </div>, document.body,
  );
};

export default Modal;
